import { lazyWithChunkReload } from "../../shared/lib/chunk-load-recovery";

export const CcfCalculationOverview = lazyWithChunkReload(() =>
  import("./calculation-overview/calculation-overview.main").then((m) => ({ default: m.CcfCalculationOverview }))
);
export const CcfCalculationResult = lazyWithChunkReload(() =>
  import("./calculation-results/calculation-results.main").then((m) => ({ default: m.CcfCalculationResult }))
);
export const CcfManagement = lazyWithChunkReload(() =>
  import("./calculations/calculations.main").then((m) => ({ default: m.CcfManagement }))
);
export const DirectCombustion = lazyWithChunkReload(() =>
  import("./data-entry-pages/combustion/direct-combustion.main").then((m) => ({ default: m.DirectCombustion }))
);
export const Scope3Combustion = lazyWithChunkReload(() =>
  import("./data-entry-pages/combustion/scope3-combustion.main").then((m) => ({ default: m.Scope3Combustion }))
);
export const DirectCooling = lazyWithChunkReload(() =>
  import("./data-entry-pages/cooling/direct-cooling.main").then((m) => ({ default: m.DirectCooling }))
);
export const Scope3Cooling = lazyWithChunkReload(() =>
  import("./data-entry-pages/cooling/scope3-cooling.main").then((m) => ({ default: m.Scope3Cooling }))
);
export const DirectElectricity = lazyWithChunkReload(() =>
  import("./data-entry-pages/electricity/direct-electricity.main").then((m) => ({ default: m.DirectElectricity }))
);
export const Scope3Electricity = lazyWithChunkReload(() =>
  import("./data-entry-pages/electricity/scope3-electricity.main").then((m) => ({ default: m.Scope3Electricity }))
);
export const EmployeeCommutingMain = lazyWithChunkReload(() =>
  import("./data-entry-pages/employee-commuting/employee-commuting.main").then((m) => ({
    default: m.EmployeeCommutingMain,
  }))
);
export const ExternalDataCenter = lazyWithChunkReload(() =>
  import("./data-entry-pages/external-data-center/external-data-center.main").then((m) => ({
    default: m.ExternalDataCenter,
  }))
);
export const ExternallyCalculated = lazyWithChunkReload(() =>
  import("./data-entry-pages/externally-calculated/externally-calculated").then((m) => ({
    default: m.ExternallyCalculated,
  }))
);
export const Flight = lazyWithChunkReload(() =>
  import("./data-entry-pages/flight/flight.main").then((m) => ({ default: m.Flight }))
);
export const FoodAndBeverages = lazyWithChunkReload(() =>
  import("./data-entry-pages/food-and-beverages/food-and-beverages.main").then((m) => ({ default: m.FoodAndBeverages }))
);
export const DirectFugitive = lazyWithChunkReload(() =>
  import("./data-entry-pages/fugitive/direct-fugitive.main").then((m) => ({ default: m.DirectFugitive }))
);
export const Scope3Fugitive = lazyWithChunkReload(() =>
  import("./data-entry-pages/fugitive/scope3-fugitive.main").then((m) => ({ default: m.Scope3Fugitive }))
);
export const Heating = lazyWithChunkReload(() =>
  import("./data-entry-pages/heating/heating.main").then((m) => ({ default: m.Heating }))
);
export const HotelStays = lazyWithChunkReload(() =>
  import("./data-entry-pages/hotel-stays/hotel-stays.main").then((m) => ({ default: m.HotelStays }))
);
export const InboundLogisticsContainer = lazyWithChunkReload(() =>
  import("./data-entry-pages/logistics/inbound-logistics/inbound-logistics").then((m) => ({
    default: m.InboundLogisticsContainer,
  }))
);
export const IntralogisticsContainer = lazyWithChunkReload(() =>
  import("./data-entry-pages/logistics/intralogistics/intralogistics").then((m) => ({
    default: m.IntralogisticsContainer,
  }))
);
export const OutboundLogisticsContainer = lazyWithChunkReload(() =>
  import("./data-entry-pages/logistics/outbound-logistics/outbound-logistics").then((m) => ({
    default: m.OutboundLogisticsContainer,
  }))
);
export const MaterialDataEntryPage = lazyWithChunkReload(() =>
  import("./data-entry-pages/materials/material-data-entry-page").then((m) => ({ default: m.MaterialDataEntryPage }))
);
export const PrivateAndRentalVehicle = lazyWithChunkReload(() =>
  import("./data-entry-pages/private-and-rental-vehicles/private-and-rental-vehicles.main").then((m) => ({
    default: m.PrivateAndRentalVehicle,
  }))
);
export const RailTravel = lazyWithChunkReload(() =>
  import("./data-entry-pages/rail-travel/rail-travel.main").then((m) => ({ default: m.RailTravel }))
);
// Lazy although it is only the layout: its side nav reaches every data-entry page through
// `shared/emission-source-hierarchy/config.ts`, so loading it eagerly would pull them all back in.
export const DataEntryPage = lazyWithChunkReload(() =>
  import("./data-entry-pages/shared/data-entry-page").then((m) => ({ default: m.DataEntryPage }))
);
export const VehicleFleet = lazyWithChunkReload(() =>
  import("./data-entry-pages/vehicle-fleet/vehicle-fleet.main").then((m) => ({ default: m.VehicleFleet }))
);
export const Disposal = lazyWithChunkReload(() =>
  import("./data-entry-pages/waste/disposal/disposal.main").then((m) => ({ default: m.Disposal }))
);
export const ProcessingOfSoldProductsWaste = lazyWithChunkReload(() =>
  import("./data-entry-pages/waste/processing-of-sold-products-waste/processing-of-sold-products-waste.main").then(
    (m) => ({ default: m.ProcessingOfSoldProductsWaste })
  )
);
export const ProductDisposal = lazyWithChunkReload(() =>
  import("./data-entry-pages/waste/product-disposal/product-disposal.main").then((m) => ({
    default: m.ProductDisposal,
  }))
);
export const Water = lazyWithChunkReload(() =>
  import("./data-entry-pages/water/water.main").then((m) => ({ default: m.Water }))
);
